import { Avatar, Divider, ListItemIcon, Menu, MenuItem, Theme, Tooltip, Typography, useTheme } from "@mui/material";
import { Lock, Logout } from "@mui/icons-material";
import { useState } from "react";
import { canMaintainAdminPassword, ensureToken, logout } from "../../store/actions/LoginActions";
import { KNISTR_BLUE } from "../atoms/ImsMaterialTheme";
import ChangePassword from "../user/ChangePassword";
import ShowRoles from "../user/ShowRoles";
import { useTranslation } from "react-i18next";

const styles = (theme: Theme) => ({
  avatar: {
    backgroundColor: KNISTR_BLUE,
    height: theme.spacing(4.5),
    width: theme.spacing(4.5),
    cursor: "pointer",
  },
  userInfo: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
});

const AvatarMenu = () => {
  const theme = useTheme();
  const classes = styles(theme);
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [showRolesVisible, setShowRolesVisible] = useState(false);
  const { t } = useTranslation();

  const loyaltyToken = ensureToken();
  const username = loyaltyToken?.username ?? "";
  const fullName = `${loyaltyToken?.firstname ?? ""} ${loyaltyToken?.lastname ?? ""}`.trim();
  const email = loyaltyToken?.email ?? "";

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {changePasswordVisible && <ChangePassword setChangePasswordVisible={setChangePasswordVisible} />}
      {showRolesVisible && <ShowRoles setShowRolesVisible={setShowRolesVisible} />}
      <Tooltip title={fullName}>
        <Avatar data-testid="avatar" sx={classes.avatar} onClick={handleClick}></Avatar>
      </Tooltip>
      <Menu
        id="avatar-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {(fullName || username || email) && (
          <Typography sx={classes.userInfo}>
            {fullName} {username && `(${username})`}
            <br />
            {email}
          </Typography>
        )}
        <Divider />
        {canMaintainAdminPassword() && (
          <MenuItem
            onClick={() => {
              setChangePasswordVisible(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Lock />
            </ListItemIcon>
            {t("account.password.change")}
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            logout();
          }}
        >
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          {t("account.logout")}
        </MenuItem>
      </Menu>
    </>
  );
};
export default AvatarMenu;
